import { FIELDS } from './constants';
import { INSURANCE_NAMEPLATES } from './resources';

export const initialState = {
  [FIELDS.APPLICATIONS]: {},
  [FIELDS.BANKS_FETCH]: false,
  [FIELDS.ERRORS]: {},
  [FIELDS.NAMEPLATE]: INSURANCE_NAMEPLATES.unknown,
  [FIELDS.LAST_MODIFIED_AT]: 0,
  [FIELDS.FETCH_STATES]: {},
  [FIELDS.INSURANCE_MAIN_FETCH_STATES]: {},
  [FIELDS.APPLICATIONS_POPUP_DATA]: {},
  [FIELDS.DEALER_LEGALS]: { currentDealerId: null, legalsList: [] },
  ///
  [FIELDS.IS_IN_CREDIT]: true,
  [FIELDS.INSURANCE_BANKS]: [],
  [FIELDS.SELECTED_BANK]: null,
  ///
  [FIELDS.MULTIDRIVE]: false,
  [FIELDS.CURRENT_MULTIDRIVE]: false,
};
